import offGreenIcon from 'assets/smart_indicator_green_off.svg';
import onGreenIcon from 'assets/smart_indicator_green_on.svg';
import offRedIcon from 'assets/smart_indicator_red_off.svg';
import onRedIcon from 'assets/smart_indicator_red_on.svg';
import { MNEMONICS } from 'constants/mnemonics';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MnemonicsMappingDTO } from 'types/mnemonicsMapping';
import { OFFSHORE_SUBSEA, OFFSHORE_SURFACE, ONSHORE } from 'types/wellbore';

import styles from './BoosterCheck.module.scss';

interface Props {
  locationType?: string;
  isFlowinBstNa: boolean;
  mnemonicsMapping?: MnemonicsMappingDTO;
}

const BoosterCheck: React.FC<Props> = ({ locationType, isFlowinBstNa, mnemonicsMapping }) => {
  const getLocationType = () => {
    if (
      locationType === ONSHORE ||
      locationType === OFFSHORE_SUBSEA ||
      locationType === OFFSHORE_SURFACE
    ) {
      return (
        <div className={styles.secondaryCheck}>
          <FormattedMessage
            id="dataManagement.dataQuality.dataConsistency.boosterCheck.locationType"
            values={{ locationType }}
          />
        </div>
      );
    }

    return null;
  };

  const getMpdMappingStatus = () => {
    if (mnemonicsMapping?.timeData.MPDSBP) {
      return (
        <div className={styles.secondaryCheck}>
          <FormattedMessage id="dataManagement.dataQuality.dataConsistency.boosterCheck.mpdMapped" />
        </div>
      );
    }

    return null;
  };

  const getMainBoosterCheck = () => {
    if (isFlowinBstNa)
      return (
        <>
          <img src={offGreenIcon} alt="offGreenIcon" className={styles.alarmIcon} />
          <img src={offRedIcon} alt="offRedIcon" className={styles.alarmIcon} />
        </>
      );
    if (mnemonicsMapping?.timeData[MNEMONICS.FLOWIN_BST]?.live) {
      return (
        <>
          <img src={onGreenIcon} alt="onGreenIcon" className={styles.alarmIcon} />
          <img src={offRedIcon} alt="offRedIcon" className={styles.alarmIcon} />
        </>
      );
    }

    return (
      <>
        <img src={offGreenIcon} alt="offGreenIcon" className={styles.alarmIcon} />
        <img src={onRedIcon} alt="onRedIcon" className={styles.alarmIcon} />
      </>
    );
  };

  return (
    <div>
      <div className={styles.mainCheck}>
        <div className={styles.title}>
          <FormattedMessage id="dataManagement.dataQuality.dataConsistency.boosterCheck.title" />
        </div>
        {getMainBoosterCheck()}
      </div>
      {getLocationType()}
      {getMpdMappingStatus()}
    </div>
  );
};

export default BoosterCheck;
